import { PermissionMatrix } from '@/components/acl/PermissionMatrix';
import AppLayout from '@/components/layout/AppLayout';
import * as Sentry from '@sentry/react';

const Access = () => {
  return (
    <AppLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Access Control</h1>
          <p className="text-muted-foreground">
            Manage role-based permissions for your organization
          </p>
        </div>

        <PermissionMatrix />
      </div>
    </AppLayout>
  );
};

export default Sentry.withProfiler(Access);
